/* RFC: formato, fecha real (AAMMDD) y régimen compatible con persona moral (12) o física (13). Regresa '' si está bien
   o el motivo en texto. Evita que entren RFC que el SAT rechaza al timbrar (pedido 20274, 21 oct 2026). */
window.mutioRfc = (rfc, regimen) => {
  const r = String(rfc || '').trim().toUpperCase();
  const m = /^([A-ZÑ&]{3,4})(\d{2})(\d{2})(\d{2})([A-Z0-9]{3})$/.exec(r);
  if (!m) return 'RFC válido (12 caracteres empresa, 13 persona física)';
  if (/^X[AE]XX010101000$/.test(r)) return 'tu RFC (el genérico de público en general no sirve para factura)';
  const mes = +m[3]; const dia = +m[4];
  const max = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][mes - 1];
  if (!max || dia < 1 || dia > max) return 'RFC válido: la fecha ' + m[2] + m[3] + m[4] + ' no existe (año, mes, día); revísalo en tu Constancia de Situación Fiscal';
  if (regimen) {
    const moral = r.length === 12;
    const ok = moral ? ['601', '603', '620', '622', '623', '624', '626'] : ['605', '606', '607', '608', '610', '611', '612', '614', '615', '616', '621', '625', '626'];
    if (!ok.includes(String(regimen))) return 'régimen compatible con ' + (moral ? 'empresa (persona moral)' : 'persona física');
  }
  return '';
};

/* Mutio: menú, verificación de edad, contador de campaña, barra de envío y datos de factura. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const store = {
    get(k) { try { return localStorage.getItem(k) || sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v, keep) { try { (keep ? localStorage : sessionStorage).setItem(k, v); } catch (e) {} },
    del(k) { try { localStorage.removeItem(k); sessionStorage.removeItem(k); } catch (e) {} }
  };

  /* Menú por departamentos (escritorio) */
  const closeMegas = () => {
    $$('[data-m-mega]').forEach((m) => m.classList.remove('is-open'));
    $$('[data-m-mega-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
  };
  $$('[data-m-mega-toggle]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const id = btn.dataset.mMegaToggle;
      const panel = $(`[data-m-mega="${id}"]`);
      const open = panel && !panel.classList.contains('is-open');
      closeMegas();
      if (open) { panel.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    });
  });
  document.addEventListener('click', (e) => { if (!e.target.closest('[data-m-mega]')) closeMegas(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeMegas(); closeDrawer(); } });

  /* Menú en celular */
  const drawer = $('[data-m-drawer]');
  const closeDrawer = () => { if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; } };
  $$('[data-m-drawer-open]').forEach((b) => b.addEventListener('click', () => { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }));
  $$('[data-m-drawer-close]').forEach((b) => b.addEventListener('click', closeDrawer));

  /* Verificación de edad: adulto ve todo; menor navega sin vinos ni licores */
  const applyAge = (age) => {
    const minor = age === 'minor';
    document.documentElement.classList.toggle('m-no-alcohol', minor);
    $$('.m-only-adult').forEach((el) => { el.hidden = minor; });
    $$('.m-only-minor').forEach((el) => { el.hidden = !minor; });
  };
  const gate = $('[data-m-age]');
  const saved = store.get('m_age');
  applyAge(saved);
  if (gate && !saved) gate.classList.add('is-open');
  if (gate) {
    const choose = (age) => {
      const keep = $('[data-m-age-remember]', gate)?.checked;
      store.set('m_age', age, keep);
      applyAge(age);
      gate.classList.remove('is-open');
    };
    $('[data-m-age-yes]', gate)?.addEventListener('click', () => choose('adult'));
    $('[data-m-age-no]', gate)?.addEventListener('click', () => choose('minor'));
  }
  window.mutioResetAge = () => { store.del('m_age'); location.reload(); };

  /* Contador de campaña */
  const pad = (n) => String(Math.max(0, n)).padStart(2, '0');
  const tick = () => {
    const now = Date.now() / 1000;
    $$('[data-m-countdown]').forEach((el) => {
      let s = Math.max(0, Math.floor(Number(el.dataset.end) - now));
      const d = Math.floor(s / 86400); s -= d * 86400;
      const h = Math.floor(s / 3600); s -= h * 3600;
      const m = Math.floor(s / 60); s -= m * 60;
      $('[data-d]', el).textContent = pad(d); $('[data-h]', el).textContent = pad(h);
      $('[data-m]', el).textContent = pad(m); $('[data-s]', el).textContent = pad(s);
    });
    $$('[data-m-countdown-short]').forEach((el) => {
      let s = Math.max(0, Math.floor(Number(el.dataset.end) - now));
      const d = Math.floor(s / 86400); const h = Math.floor((s % 86400) / 3600);
      el.textContent = ` · termina en ${d} d ${h} h`;
    });
  };
  if ($('[data-m-countdown], [data-m-countdown-short]')) { tick(); setInterval(tick, 1000); }

  /* Barra de envío por escalones */
  const escH = (t) => String(t ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = (cents) => '$' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const money0 = (cents) => '$' + Math.round(cents / 100).toLocaleString('es-MX');
  // Envío estimado por peso (tarifas de Shopify en mutio.promos.envio_peso = [[hasta_kg, precio], …]).
  const envioPorPeso = (grams, tiers) => { if (!tiers || !(grams > 0)) return null; const kg = grams / 1000; const t = tiers.find(([max]) => kg <= max); return t ? Math.round(t[1] * 100) : null; };
  const paintShipIn = (root, total, grams) => {
    $$('[data-m-ship]', root).forEach((bar) => {
      const free = Number(bar.dataset.free); const mid = Number(bar.dataset.mid); const cost = Number(bar.dataset.midCost);
      const amt = total == null ? Number(bar.dataset.amount) : total;
      let tiers = null; try { tiers = bar.dataset.peso ? JSON.parse(bar.dataset.peso) : null; } catch {}
      if (grams != null) bar.dataset.grams = grams;
      let msg;
      if (amt >= free) msg = 'Tu envío es gratis';
      else if (tiers) { const est = envioPorPeso(Number(bar.dataset.grams), tiers); msg = `${est != null ? `Envío estimado ${money0(est)} · ` : ''}te faltan ${money(free - amt)} para envío gratis`; }
      else if (amt >= mid) msg = `Envío de ${money0(cost)} · te faltan ${money(free - amt)} para envío gratis`;
      else msg = `Te faltan ${money(mid - amt)} para envío de ${money0(cost)}`;
      bar.classList.toggle('is-free', amt >= free);
      $('[data-m-ship-msg]', bar).textContent = msg;
      $('[data-m-ship-fill]', bar).style.width = Math.min(100, (amt / free) * 100) + '%';
    });
  };
  const paintShip = (total, grams) => paintShipIn(document, total, grams);
  const refreshCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then((r) => r.json())
    .then((c) => {
      paintShip(c.total_price, c.total_weight);
      const badge = $('[data-m-cart-count]');
      if (badge) badge.textContent = c.item_count;
    })
    .catch(() => {});
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCart);
  document.addEventListener('cart:updated', refreshCart);

  /* ===== Ficha de producto ===== */
  const pdp = $('[data-m-pdp]');
  if (pdp) {
    const variants = JSON.parse($('[data-m-variants]')?.textContent || '[]');
    const form = $('[data-m-add-form]', pdp);
    const idInput = $('[data-m-variant-id]', pdp);
    let current = variants.find((v) => String(v.id) === idInput?.value) || variants[0];
    const fmt = (c) => '$' + (c / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    let subOn = false;
    const modesEl = $('[data-m-desc]', pdp);
    const desc = Number(modesEl?.dataset.mDesc || 0);
    // Pack con suscripción por piezas: en "Recíbelo seguido" se compra la botella sola × piezas.
    const subVar = modesEl?.dataset.mSubVariant ? { id: Number(modesEl.dataset.mSubVariant), qty: Number(modesEl.dataset.mSubQty), cents: Number(modesEl.dataset.mSubCents) } : null;
    // Meses sin intereses: los que da hoy Mercado Pago (data-m-msi-meses) y solo arriba del mínimo (data-m-msi-min).
    const pintaMsi = (cents) => { const p = $('[data-m-msi-meses]', pdp); const s = $('[data-m-msi]', pdp); if (!s) return; const n = Number(p?.dataset.mMsiMeses) || 3; const min = Number(p?.dataset.mMsiMin) || 0; if (p) p.hidden = cents < min; s.textContent = fmt(Math.round(cents / n)); };
    const setVariant = (v0) => {
      current = v0; idInput.value = v0.id;
      const baseSub = subOn && subVar ? subVar.cents : v0.price;
      const v = { ...v0, price: subOn && desc ? Math.round(baseSub * (100 - desc) / 100) : baseSub };
      $$('[data-m-price]', pdp).forEach((el) => { el.textContent = fmt(v.price); });
      pintaMsi(v.price);
      const btn = $('[data-m-add]', pdp);
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Agregar al carrito' : 'Agotado';
      $$('[data-m-ship]', pdp).forEach((bar) => { bar.dataset.amount = v.price; });
      paintShipIn(pdp, v.price, v.weight != null ? v.weight : undefined);
      $$('[data-m-variant]', pdp).forEach((b) => b.classList.toggle('is-active', b.dataset.mVariant === String(v.id)));
    };
    $$('[data-m-variant]', pdp).forEach((b) => b.addEventListener('click', () => {
      const v = variants.find((x) => String(x.id) === b.dataset.mVariant); if (v) setVariant(v);
    }));
    const photo = $('.m-pdp__photo', pdp); const img0 = $('.m-pdp__img', pdp);
    $$('[data-m-thumb], [data-m-video], [data-m-embed]', pdp).forEach((b) => b.addEventListener('click', () => {
      if (!photo) return;
      if (b.dataset.mThumb) {
        if (img0) { img0.src = b.dataset.mThumb; img0.removeAttribute('srcset'); if (!photo.contains(img0)) { photo.innerHTML = ''; photo.appendChild(img0); } }
        if (photo.hasAttribute('data-m-foto-fondo')) photo.style.setProperty('--foto', `url(${b.dataset.mThumb.replace(/width=\d+/, 'width=80')})`);
      } else if (b.dataset.mVideo) {
        photo.innerHTML = `<video class="m-pdp__video" src="${b.dataset.mVideo}" controls autoplay muted playsinline></video>`;
      } else if (b.dataset.mEmbed) {
        photo.innerHTML = `<iframe class="m-pdp__video" src="${b.dataset.mEmbed}" allow="autoplay; fullscreen" allowfullscreen title="Video"></iframe>`;
      }
      $$('.m-pdp__thumb', pdp).forEach((x) => x.classList.toggle('is-active', x === b));
    }));
    /* Cantidad (ficha Premium) */
    const qtyBox = $('[data-m-qty]', pdp);
    if (qtyBox) {
      const qi = $('input', qtyBox);
      $$('[data-m-qty-step]', qtyBox).forEach((b) => b.addEventListener('click', () => {
        const max = Number(qi.max) || 99;
        qi.value = Math.min(max, Math.max(1, (Number(qi.value) || 1) + Number(b.dataset.mQtyStep)));
      }));
    }
    /* Una vez o recurrente */
    const plans = $('[data-m-plans]', pdp); const planInput = $('[data-m-plan-input]', pdp);
    $$('[data-m-mode]', pdp).forEach((b) => b.addEventListener('click', () => {
      const sub = b.dataset.mMode === 'sub';
      subOn = sub; setVariant(current);
      $$('[data-m-mode]', pdp).forEach((x) => { x.classList.toggle('is-active', x === b); x.setAttribute('aria-checked', x === b); });
      if (plans) plans.hidden = !sub;
      const note = $('[data-m-sub-note]', pdp); if (note) note.hidden = !sub;
      if (planInput) { planInput.disabled = !sub; planInput.value = sub ? ($('[data-m-plan].is-active', pdp)?.dataset.mPlan || '') : ''; }
    }));
    $$('[data-m-plan]', pdp).forEach((b) => b.addEventListener('click', () => {
      $$('[data-m-plan]', pdp).forEach((x) => x.classList.toggle('is-active', x === b));
      if (!subOn) $('[data-m-mode="sub"]', pdp)?.click();
      if (planInput) planInput.value = b.dataset.mPlan;
    }));

    /* Panel al agregar + quienes compran */
    const sheet = $('[data-m-sheet]');
    const closeSheet = () => { if (sheet) sheet.hidden = true; };
    $$('[data-m-sheet-close]').forEach((b) => b.addEventListener('click', closeSheet));
    sheet?.addEventListener('click', (e) => { if (e.target === sheet) closeSheet(); });
    let recs = [];
    const recCard = (p, btn) => `<div class="m-sheet__rec"><img src="${p.featured_image || ''}" alt=""><div><span>${p.title}</span><strong>${fmt(p.price)}</strong></div>${btn ? `<button type="button" data-m-quick="${p.variants[0].id}">+ ${fmt(p.price).replace(' MXN', '')}</button>` : ''}</div>`;
    const fillSheet = (cart) => {
      $('[data-m-sheet-total]', sheet).textContent = 'Carrito: ' + fmt(cart.total_price);
      const shipTpl = $('[data-m-ship]', pdp);
      const shipBox = $('[data-m-sheet-ship]', sheet);
      if (shipTpl && shipBox) { shipBox.innerHTML = shipTpl.outerHTML; paintShipIn(shipBox, cart.total_price, cart.total_weight); }
      const box = $('[data-m-sheet-recs]', sheet);
      box.innerHTML = recs.length ? `<p style="font-weight:700;font-size:1.5rem;margin:0 0 1rem;">Quienes compran este, también se llevan</p>${recs.slice(0, 3).map((p) => recCard(p, true)).join('')}` : '';
      $$('[data-m-quick]', box).forEach((b) => b.addEventListener('click', async () => {
        b.disabled = true; b.textContent = 'Listo';
        const c = await addItems([{ id: Number(b.dataset.mQuick), quantity: 1 }]);
        if (c) { $('[data-m-sheet-total]', sheet).textContent = 'Carrito: ' + fmt(c.total_price); paintShipIn(shipBox, c.total_price); }
      }));
    };
    const addItems = async (items) => {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!r.ok) { const e = await r.json().catch(() => ({})); alertInline(e.description || 'No se pudo agregar.'); return null; }
      const cart = await (await fetch('/cart.js')).json();
      const badge = $('[data-m-cart-count]'); if (badge) badge.textContent = cart.item_count;
      return cart;
    };
    const alertInline = (msg) => {
      let n = $('[data-m-add-error]', pdp);
      if (!n) { n = document.createElement('p'); n.dataset.mAddError = ''; n.style.cssText = 'color:#B3261E;font-weight:600;font-size:1.4rem;margin:0;'; form.appendChild(n); }
      n.textContent = msg;
    };
    // Lo que se manda al carrito. La ficha con packs lo cambia (cantidad en botellas → pack o botellas sueltas).
    pdp.armarItem = () => {
      const qtyIn = $('[data-m-qty] input', pdp);
      const item = { id: Number(idInput.value), quantity: Math.max(1, Number(qtyIn?.value) || 1) };
      if (planInput && !planInput.disabled && planInput.value) {
        item.selling_plan = Number(planInput.value);
        if (subVar) { item.id = subVar.id; item.quantity = subVar.qty; }
      }
      return item;
    };
    form?.addEventListener('submit', async (e) => {
      e.preventDefault();
      const items = pdp.armarItems ? pdp.armarItems() : [pdp.armarItem()];
      const cart = await addItems(items);
      if (cart && sheet) { fillSheet(cart); sheet.hidden = false; }
    });

    /* Recomendaciones: se llevan juntos y parecidos */
    // Productos internos (cargos de servicio, tarjetas de regalo, "Actividades de venta…") nunca se recomiendan.
    const esOculto = (p) => /^(servicios? de|plan de activaci|prueba paypal|tarjeta de regalo|personalizaci[oó]n de producto|actividades de ventas?)/i.test((p.title || '').trim()) || /promoci[oó]n de negocios/i.test(p.title || '') || (p.tags || []).includes('oculto');
    const loadRecs = async (url) => { try { const r = await fetch(url.replace('?', '.json?')); return ((await r.json()).products || []).filter((p) => !esOculto(p)); } catch (e) { return []; } };
    const together = $('[data-m-together]');
    // Primero lo que de verdad se compra junto (ventas de todos los canales, mutio.juntos); si no hay, lo de Shopify.
    const juntos = (together?.dataset.juntos || '').split(',').filter(Boolean);
    const loadJuntos = async () => (await Promise.all(juntos.map((h) => fetch(`/products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)))).filter((p) => p && !esOculto(p));
    if (together) (juntos.length ? loadJuntos() : loadRecs(together.dataset.url)).then(async (list) => {
      const deVentas = juntos.length > 0 && list.length > 0;
      if (!list.length) list = await loadRecs(together.dataset.url);
      if (!list.length) list = await loadRecs(together.dataset.url.replace('intent=complementary', 'intent=related'));
      // Nada de la misma familia (sus packs) ni packs en general: se recomienda otra botella suelta.
      const familia = new Set((together.dataset.family || '').split(',').filter(Boolean).map(Number));
      const esPack = (t) => /^(pack|caja|paquete)\s+de\s+\d/i.test(t || '') || /^\d+\s*x\s*\d+/i.test(t || '');
      recs = list.filter((p) => p.available && !familia.has(p.id) && !esPack(p.title));
      // Que acompañen al precio de lo que ves: primero lo que cuesta entre 0.4× y 1.6×, luego lo más cercano.
      const base = current?.price || 0;
      if (base && !deVentas) {
        const dist = (p) => Math.abs(Math.log((p.price || 1) / base));
        const banda = recs.filter((p) => p.price >= base * 0.4 && p.price <= base * 1.6);
        recs = banda.concat(recs.filter((p) => !banda.includes(p)).sort((a, b) => dist(a) - dist(b)));
      }
      const two = recs.slice(0, 2);
      if (!two.length) return;
      const off = new Set();
      const render = () => {
        const sel = [current].concat(two.filter((p) => !off.has(p.id)).map((p) => p.variants[0]));
        const total = sel.reduce((a, v) => a + v.price, 0);
        const esc = (s) => String(s || '').replace(/</g, '&lt;');
        const card = (img, name, price, id, locked, url) => `<label class="m-tg${!locked && off.has(id) ? ' is-off' : ''}"><input type="checkbox" ${locked ? 'checked disabled' : (off.has(id) ? '' : 'checked')} data-m-tog="${id}"><span class="m-tg__img"><img src="${img || ''}" alt="" loading="lazy"></span><span class="m-tg__txt"><small>${locked ? 'Este producto' : 'Se lleva junto'}</small>${url ? `<a href="${url}" class="m-tg__name">${esc(name)}</a>` : `<span class="m-tg__name">${esc(name)}</span>`}<strong>${fmt(price).replace(' MXN', '')}</strong></span></label>`;
        $('[data-m-together-list]', together).innerHTML =
          `<div class="m-together__items m-tg__list">${card($('.m-pdp__img', pdp)?.src, document.querySelector('.m-pdp__title').textContent, current.price, 0, true)}${two.map((p) => card(p.featured_image, p.title, p.price, p.id, false, p.url || `/products/${p.handle}`)).join('')}</div>` +
          `<div class="m-together__sum"><div style="display:flex;flex-direction:column;gap:.6rem"><span style="font-size:1.4rem;color:#D0D2D6;font-weight:600">${sel.length > 1 ? `Los ${sel.length} juntos` : 'Solo este producto'}</span><b>${fmt(total).replace(' MXN', '')}</b><span data-m-tship style="font-size:1.4rem;font-weight:700;color:#FFBF1F"></span></div><button type="button" class="m-btn m-btn--amber" data-m-add-all>${sel.length > 1 ? `Agregar los ${sel.length} al carrito` : 'Agregar al carrito'}</button></div>`;
        const ship = $('[data-m-ship]', pdp);
        if (ship) { const free = +ship.dataset.free, mid = +ship.dataset.mid; $('[data-m-tship]', together).textContent = total >= free ? 'Con envío gratis' : ship.dataset.peso ? 'Envío según peso' : total >= mid ? `Con envío de ${money0(+ship.dataset.midCost)}` : 'Envío según tu CP'; }
        $$('[data-m-tog]', together).forEach((c) => c.addEventListener('change', () => { const id = Number(c.dataset.mTog); if (c.checked) off.delete(id); else off.add(id); render(); }));
        $('[data-m-add-all]', together).addEventListener('click', async () => {
          const items = sel.map((v) => ({ id: v.id, quantity: 1 }));
          const cart = await addItems(items);
          if (cart && sheet) { fillSheet(cart); sheet.hidden = false; }
        });
      };
      render();
      together.hidden = false;
    });
    /* Productos relacionados (ficha v2): carrusel con flechas */
    const related = $('[data-m-related]');
    if (related) loadRecs(related.dataset.url).then((list) => {
      const fam = new Set(($('[data-m-together]')?.dataset.family || '').split(',').filter(Boolean).map(Number));
      const esPackRel = (t) => /^(pack|caja|paquete|kit)\s+de\s+\d/i.test(t || '') || /^\d+\s*x\s*\d+/i.test(t || '');
      list = list.filter((p) => p.available && !fam.has(p.id) && !esPackRel(p.title));
      if (!list.length) return;
      const tr = $('[data-m-rel-track]', related);
      tr.innerHTML = list.map((p) => `<a class="m-card m-pdp2__relcard" href="${p.url}"><span class="m-card__img"><img src="${p.featured_image || ''}" alt="" loading="lazy"></span><span class="m-card__name">${p.title.replace(/</g, '&lt;')}</span><span class="m-card__price">${fmt(p.price).replace(' MXN', '')}</span></a>`).join('');
      const paso = () => tr.clientWidth * 0.9;
      $('[data-m-rel-prev]', related)?.addEventListener('click', () => tr.scrollBy({ left: -paso(), behavior: 'smooth' }));
      $('[data-m-rel-next]', related)?.addEventListener('click', () => tr.scrollBy({ left: paso(), behavior: 'smooth' }));
      related.hidden = false;
    });
    /* Comprar ahora: agrega y va directo a pagar */
    $('[data-m-buy-now]', pdp)?.addEventListener('click', async (e) => {
      const b = e.currentTarget; b.disabled = true;
      const items = pdp.armarItems ? pdp.armarItems() : [pdp.armarItem()];
      const cart = await addItems(items);
      if (cart) location.href = '/checkout'; else b.disabled = false;
    });
    /* Packs y cantidad juntos (ficha combinada): la cantidad cuenta botellas. Si hay un pack de exactamente esa
       cantidad se compra el pack (1 pieza); si no, botellas sueltas × cantidad. Elegir un pack mueve la cantidad, sin recargar. */
    const tiles = $$('.m-pdp2__tiles [data-n]', pdp);
    const qSync = $('[data-m-qty] input', pdp);
    if (tiles.length && qSync) {
      const opciones = tiles.map((a) => ({ a, n: Number(a.dataset.n), id: Number(a.dataset.variant), cents: Number(a.dataset.cents), ok: a.dataset.available === 'true', url: a.getAttribute('href') }));
      const sola = opciones.find((o) => o.n === 1);
      const unidad = $('[data-m-per]', pdp)?.dataset.unidad || 'botella';
      qSync.max = 120;
      let elegida = null;
      // La combinación más barata para u botellas (p. ej. 7 = caja de 6 + 1 suelta), con lo que hay disponible.
      const disponibles = opciones.filter((o) => o.ok && o.id && o.cents > 0);
      const mejorCombinacion = (u) => {
        const costo = [0], paso = [null];
        for (let k = 1; k <= u; k++) {
          costo[k] = Infinity; paso[k] = null;
          for (const o of disponibles) if (o.n <= k && costo[k - o.n] + o.cents < costo[k]) { costo[k] = costo[k - o.n] + o.cents; paso[k] = o; }
        }
        if (!isFinite(costo[u])) return null;
        const cuenta = new Map(); for (let k = u; k > 0; k -= paso[k].n) cuenta.set(paso[k], (cuenta.get(paso[k]) || 0) + 1);
        return { total: costo[u], items: [...cuenta.entries()].sort((a, b) => b[0].n - a[0].n).map(([o, q]) => ({ id: o.id, quantity: q })) };
      };
      const pintar = () => {
        const u = Math.max(1, Math.min(120, Number(qSync.value) || 1)); qSync.value = u;
        const pack = opciones.find((o) => o.n === u && o.ok && o.n > 1);
        elegida = pack || sola || null;
        const cantidad = pack ? 1 : u;
        const combo = mejorCombinacion(u);
        let total = combo ? combo.total : (elegida ? elegida.cents * cantidad : current.price * u);
        // Recurrente: botellas sueltas con el % del plan y, encima, el descuento automático por pieza según cuántas
        // (Shopify: "Suscripción por piezas: N o más"). Así la recurrente siempre sale igual o más barata que la caja.
        if (subOn && sola) {
          const tiers = (modesEl?.dataset.mSubTiers || '').split(',').map((x) => x.split(':').map(Number)).filter(([n, m]) => n > 0 && m >= 0);
          // Solo se resta cuando el descuento sí se aplica en el carrito (data-m-sub-tiers-ok); si no, se muestra lo que se cobra.
          const off = modesEl?.dataset.mSubTiersOk === 'true' ? tiers.filter(([n]) => n <= u).reduce((a, [, m]) => Math.max(a, m), 0) : 0;
          const cadaUna = Math.max(0, Math.round(sola.cents * (100 - desc) / 100) - Math.round(off * 100));
          total = cadaUna * u;
        }
        if (elegida) idInput.value = elegida.id;
        $$('[data-m-price]', pdp).forEach((el) => { el.textContent = fmt(total); });
        pintaMsi(total);
        const per = $('[data-m-per]', pdp);
        if (per) { per.hidden = u < 2; per.textContent = `${fmt(Math.round(total / u))} por ${unidad} · ${u} ${unidad}s`; }
        const gUnit = Number($('[data-m-ship]', pdp)?.dataset.gramsUnit || 0);
        $$('[data-m-ship]', pdp).forEach((bar) => { bar.dataset.amount = total; }); paintShipIn(pdp, total, gUnit ? gUnit * u : undefined);
        // En recurrente, cada mosaico muestra su precio por botella de suscripción (plan + descuento por pieza) y el ahorro
        // contra la botella suelta en compra única. En compra única, lo de siempre.
        const tiersR = (modesEl?.dataset.mSubTiers || '').split(',').map((x) => x.split(':').map(Number)).filter(([n, m]) => n > 0 && m >= 0);
        const tiersOk = modesEl?.dataset.mSubTiersOk === 'true';
        opciones.forEach((o) => {
          const each = $('.m-pdp2__tileeach', o.a); const save = $('.m-pdp2__tilesave', o.a);
          if (!each) return;
          if (!o.a.dataset.eachOrig) { o.a.dataset.eachOrig = each.innerHTML; o.a.dataset.saveOrig = save ? save.outerHTML : ''; }
          if (subOn && sola) {
            const off = tiersOk ? tiersR.filter(([n]) => n <= o.n).reduce((a, [, m]) => Math.max(a, m), 0) : 0;
            const c = Math.max(0, Math.round(sola.cents * (100 - desc) / 100) - Math.round(off * 100));
            each.innerHTML = `${fmt(c)}<small> c/u</small>`;
            const pct = Math.round((1 - c / sola.cents) * 100);
            if (save) { save.className = 'm-pdp2__tilesave'; save.textContent = pct > 0 ? `−${pct}%` : ' '; }
          } else {
            each.innerHTML = o.a.dataset.eachOrig;
            if (save && o.a.dataset.saveOrig) save.outerHTML = o.a.dataset.saveOrig;
          }
        });
        opciones.forEach((o) => { const on = o.n === u; o.a.classList.toggle('is-current', on); if (on) o.a.setAttribute('aria-current', 'true'); else o.a.removeAttribute('aria-current'); });
        const tag = $('.m-pdp__tag span', pdp); if (tag) tag.textContent = u === 1 ? `1 ${unidad}` : u >= 6 && pack ? `Caja de ${u}` : `${u} ${unidad}s`;
        const btn = $('[data-m-add]', pdp); if (btn && elegida) btn.disabled = !elegida.ok;
        const h0 = $('[data-m-packhint]', pdp); if (h0) h0.hidden = true;
        try { if (pack || u === 1) { const dest = (pack || sola).url; if (dest && dest !== location.pathname) history.replaceState(null, '', dest + location.search.replace(/[?&]view=v\d/, '')); } } catch (e) { /* sin historial */ }
      };
      pdp.armarItems = () => {
        const u = Math.max(1, Number(qSync.value) || 1);
        if (planInput && !planInput.disabled && planInput.value && sola) return [{ id: sola.id, quantity: u, selling_plan: Number(planInput.value) }];
        const combo = mejorCombinacion(u);
        return combo ? combo.items : [{ id: (sola || elegida)?.id || Number(idInput.value), quantity: u }];
      };
      pdp.armarItem = () => pdp.armarItems()[0];
      tiles.forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); qSync.value = a.dataset.n; pintar(); }));
      qSync.addEventListener('input', pintar); qSync.addEventListener('change', pintar);
      $$('[data-m-qty-step]', pdp).forEach((b) => b.addEventListener('click', () => setTimeout(pintar, 0)));
      $$('[data-m-mode]', pdp).forEach((b) => b.addEventListener('click', () => setTimeout(pintar, 0)));
      pintar();
    }
    /* Al subir la cantidad, sugerir el pack si conviene */
    const hint = $('[data-m-packhint]', pdp);
    const packs2 = $$('[data-m-packs2] [data-n]', pdp).map((a) => ({ n: Number(a.dataset.n), ahorro: Number(a.dataset.ahorro), url: a.href })).filter((x) => x.ahorro > 0);
    const qIn = $('[data-m-qty] input', pdp);
    const revisaPack = () => {
      if (!hint || !qIn || $('.m-pdp2__tiles', pdp)) return;
      const q = Number(qIn.value) || 1;
      const mejor = packs2.filter((x) => x.n <= q).sort((a, b) => b.n - a.n)[0];
      hint.hidden = !mejor;
      if (mejor) hint.innerHTML = `Llevas ${q}: con el pack de ${mejor.n} ahorras ${mejor.ahorro}%. <a href="${mejor.url}">Cambiar al pack</a>`;
    };
    qIn?.addEventListener('input', revisaPack);
    $$('[data-m-qty-step]', pdp).forEach((b) => b.addEventListener('click', () => setTimeout(revisaPack, 0)));

    const similar = $('[data-m-similar]');
    if (similar) loadRecs(similar.dataset.url).then((list) => {
      list = list.filter((p) => p.available).slice(0, window.innerWidth < 750 ? 3 : 5);
      if (!list.length) return;
      $('[data-m-similar-items]', similar).innerHTML = list.map((p) => `<a class="m-shelf__item" href="${p.url}"><img src="${p.featured_image || ''}" alt="${p.title.replace(/"/g, '')}" loading="lazy"></a>`).join('');
      $('[data-m-similar-tags]', similar).innerHTML = list.map((p) => `<a class="m-tag" href="${p.url}"><span class="m-tag__name">${p.title.length > 26 ? p.title.slice(0, 25) + '…' : p.title}</span><span class="m-tag__price">${fmt(p.price).replace(' MXN', '')}</span></a>`).join('');
      similar.hidden = false;
    });
  }

  /* ===== Colección ===== */
  const colForm = $('[data-m-filter-form]');
  if (colForm) {
    colForm.addEventListener('change', (e) => {
      const r = e.target;
      if (r.matches('[data-m-filter-q]')) return;
      if (r.dataset.mGroup) $$(`[data-m-dup="${r.dataset.mGroup}"]`, colForm).forEach((x) => { x.checked = r.checked; });
      if ('mSort2' in r.dataset) { const s = $('[data-m-sort]'); if (s) s.value = r.value; }
      if (r.name === 'm_price') {
        $('[data-m-pmin]', colForm).value = r.dataset.min !== '0' ? r.dataset.min : '';
        $('[data-m-pmax]', colForm).value = r.dataset.max !== '0' ? r.dataset.max : '';
      }
      $$('input', colForm).forEach((i) => { if (i.name === 'm_price' || (i.type === 'hidden' && !i.value)) i.disabled = true; });
      colForm.submit();
    });
    // Marcas escritas de varias formas (Don Julio / DonJulio / DON JULIO): una sola casilla que marca todas
    const claveM = (t) => t.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
    $$('[data-m-filter][data-param="filter.p.vendor"]', colForm).forEach((fs) => {
      const grupos = new Map();
      $$('.m-filter__opt', fs).forEach((lab) => { const k = claveM(lab.textContent.trim()); if (!grupos.has(k)) grupos.set(k, []); grupos.get(k).push(lab); });
      grupos.forEach((labs, k) => {
        if (labs.length < 2) return;
        const main = $('input', labs[0]); main.dataset.mGroup = k;
        labs.slice(1).forEach((l) => { const i = $('input', l); i.dataset.mDup = k; if (i.checked) main.checked = true; l.hidden = true; l.classList.add('is-dupe'); });
      });
    });
    $$('[data-m-more]', colForm).forEach((b) => b.addEventListener('click', () => { const f = b.closest('[data-m-filter]'); f.classList.add('is-all'); b.remove(); $('[data-m-filter-q]', f)?.focus(); }));
    $('[data-m-sort]')?.addEventListener('change', () => colForm.submit());
    const panel = $('[data-m-filters]');
    $('[data-m-filters-open]')?.addEventListener('click', () => panel.classList.add('is-open'));
    $('[data-m-filters-close]')?.addEventListener('click', () => panel.classList.remove('is-open'));
  }
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-m-quick-add]');
    if (!b || b.disabled) return;
    b.disabled = true;
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.dataset.mQuickAdd), quantity: 1 }] }) });
    const toast = $('[data-m-toast]');
    if (r.ok) {
      b.textContent = 'En tu carrito'; b.classList.add('is-done');
      const cart = await (await fetch('/cart.js')).json();
      const badge = $('[data-m-cart-count]'); if (badge) badge.textContent = cart.item_count;
      if (toast) { toast.innerHTML = `Agregado · Carrito ${('$' + (cart.total_price / 100).toLocaleString('es-MX', { minimumFractionDigits: 2 }))}<a href="/cart">Ver carrito</a>`; toast.hidden = false; clearTimeout(window.__mToast); window.__mToast = setTimeout(() => { toast.hidden = true; }, 3500); }
    } else { b.disabled = false; if (toast) { toast.textContent = 'No se pudo agregar. Intenta de nuevo.'; toast.hidden = false; } }
  });

  /* Top 4 del anaquel: siempre los más vendidos, sin importar página, orden o filtros */
  $$('[data-m-top-src]').forEach(async (box) => {
    try {
      const html = await (await fetch(box.dataset.mTopSrc)).text();
      const got = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-m-top]');
      if (got) box.replaceWith(got);
    } catch (_) { /* se queda sin anaquel */ }
  });

  /* Ver más productos en la misma página */
  const more = $('[data-m-load-more]');
  if (more) {
    document.documentElement.classList.add('m-has-more');
    more.addEventListener('click', async () => {
      const next = more.dataset.next; if (!next) return;
      more.disabled = true; more.textContent = 'Cargando…';
      try {
        const url = next + (next.includes('?') ? '&' : '?') + 'section_id=' + more.dataset.section;
        const doc = new DOMParser().parseFromString(await (await fetch(url)).text(), 'text/html');
        const grid = $('[data-m-grid]');
        $$('[data-m-grid] > *', doc).forEach((li) => grid.appendChild(li));
        const nb = $('[data-m-load-more]', doc);
        if (nb && nb.dataset.next) { more.dataset.next = nb.dataset.next; more.textContent = nb.textContent; more.disabled = false; }
        else more.closest('[data-m-more-wrap]').remove();
        const shown = $('[data-m-shown]'); if (shown) shown.textContent = Number(shown.dataset.offset || 0) + grid.children.length;
      } catch (_) { more.disabled = false; more.textContent = 'Ver más productos'; }
    });
  }

  /* Buscar dentro de una lista larga de filtros (marcas) */
  document.addEventListener('input', (e) => {
    const q = e.target.closest('[data-m-filter-q]'); if (!q) return;
    const t = q.value.trim().toLowerCase();
    $$('.m-filter__opt:not(.is-dupe)', q.closest('[data-m-filter]')).forEach((o) => { o.hidden = t && !o.textContent.toLowerCase().includes(t); });
  });

  /* Datos de factura → atributos del carrito */
  const inv = $('[data-m-invoice]');
  if (inv) {
    const fields = $('[data-m-invoice-fields]', inv);
    const later = $('[data-m-invoice-later]', inv);
    const status = $('[data-m-invoice-status]', inv);
    const RFC = /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/;
    let timer;
    const val = (k) => ($(`[data-m-inv="${k}"]`, inv)?.value || '').trim();
    const save = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const on = $('[data-m-invoice-toggle]', inv).checked;
        const nombre = val('nombre').toUpperCase().replace(/[\s,]+(S\.?\s?A\.?\s?(DE\s?C\.?\s?V\.?)?|S\.?\s?DE\s?R\.?\s?L\.?(\s?DE\s?C\.?\s?V\.?)?|S\.?\s?C\.?|A\.?\s?C\.?)\s*$/, '');
        const attrs = on ? {
          'Necesita factura': 'Sí', 'Factura RFC': val('rfc').toUpperCase(), 'Factura Razon social': nombre,
          'Factura Regimen': val('regimen'), 'Factura CP': val('cp'), 'Factura Uso CFDI': val('uso'), 'Factura Forma de pago': val('forma')
        } : { 'Necesita factura': '', 'Factura RFC': '', 'Factura Razon social': '', 'Factura Regimen': '', 'Factura CP': '', 'Factura Uso CFDI': '', 'Factura Forma de pago': '' };
        const missing = [];
        if (on) {
          const rfcMal = window.mutioRfc(attrs['Factura RFC'], attrs['Factura Regimen']);
          if (rfcMal) missing.push(rfcMal);
          if (!attrs['Factura Razon social']) missing.push('razón social');
          if (!/^\d{5}$/.test(attrs['Factura CP'])) missing.push('CP fiscal');
          if (!attrs['Factura Regimen']) missing.push('régimen');
        }
        if (status) status.textContent = missing.length
          ? 'Falta: ' + missing.join(', ') + '. Sin estos datos no podemos facturar.'
          : (on ? 'Listo. La factura llega a tu correo unas horas después de pagar. Es una sola factura por pedido.' : '');
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(() => {});
      }, 400);
    };
    $('[data-m-invoice-toggle]', inv).addEventListener('change', (e) => {
      fields.hidden = !e.target.checked; if (later) later.hidden = e.target.checked; save();
    });
    $$('[data-m-inv]', inv).forEach((el) => el.addEventListener('input', save));
    $$('[data-m-invoice-profile]', inv).forEach((b) => b.addEventListener('click', () => {
      const p = JSON.parse(b.dataset.mInvoiceProfile);
      const set = (k, v) => { const el = $(`[data-m-inv="${k}"]`, inv); if (el && v) el.value = v; };
      set('rfc', p.rfc); set('nombre', p.nombre); set('regimen', p.regimen); set('cp', p.cp); set('uso', p.uso);
      $$('[data-m-invoice-profile]', inv).forEach((x) => x.classList.toggle('is-active', x === b));
      save();
    }));
  }

  /* ===== Carrito (página) ===== */
  const cartRoot = $('[data-m-cart]');
  if (cartRoot && $('#m-cart-form')) {
    const sectionId = cartRoot.dataset.section;
    const toast = (msg) => { const t = $('[data-m-toast]'); if (!t) return; t.innerHTML = msg; t.hidden = false; clearTimeout(window.__mToast); window.__mToast = setTimeout(() => { t.hidden = true; }, 3500); };
    const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(async (r) => { const j = await r.json().catch(() => ({})); if (!r.ok) throw new Error(j.description || j.message || 'No se pudo actualizar'); return j; });
    const esc = (t) => String(t ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const img = (u, w) => (u ? (u.startsWith('//') ? 'https:' + u : u) + (u.includes('?') ? '&' : '?') + 'width=' + w : '');

    const rerender = async () => {
      const html = await (await fetch(`${location.pathname}?section_id=${encodeURIComponent(sectionId)}`)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      if (!doc.querySelector('#m-cart-form')) { location.reload(); return; }
      ['[data-m-cart-main]', '[data-m-cart-sum]', '[data-m-cart-count-label]'].forEach((sel) => {
        const a = $(sel, cartRoot); const b = doc.querySelector(sel); if (a && b) a.replaceWith(b);
      });
      const pay = doc.querySelector('.m-sum__pay'); const myPay = $('.m-sum__pay', cartRoot); if (pay && myPay) myPay.textContent = pay.textContent;
      const flag = $('[data-m-cart-total]', cartRoot);
      const ageBox = $('[data-m-cart-age]', cartRoot); if (ageBox && flag) ageBox.hidden = flag.dataset.alcohol !== 'true';
      initDynamic();
      refreshCart();
    };
    const busy = (key, on) => { const li = key && $(`.m-ci[data-key="${CSS.escape(key)}"]`, cartRoot); if (li) li.classList.toggle('is-busy', on); };
    const change = async (key, quantity, plan) => {
      busy(key, true);
      try {
        const body = { id: key, quantity: Number(quantity) };
        if (plan !== undefined) body.selling_plan = plan ? Number(plan) : null;
        await post('/cart/change.js', body);
        await rerender();
      } catch (e) { busy(key, false); toast(esc(e.message)); }
    };
    const addVariant = async (id, btn) => {
      if (btn) btn.disabled = true;
      try { await post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] }); await rerender(); toast('Agregado a tu carrito'); }
      catch (e) { if (btn) btn.disabled = false; toast(esc(e.message)); }
    };

    cartRoot.addEventListener('click', (e) => {
      const q = e.target.closest('[data-m-cart-qty]');
      if (q) { e.preventDefault(); change(q.dataset.mCartQty, q.dataset.q); return; }
      const s = e.target.closest('[data-m-cart-plan-set]');
      if (s) { e.preventDefault(); change(s.dataset.mCartPlanSet, s.dataset.q, s.dataset.plan); return; }
      const a = e.target.closest('[data-m-add-var]');
      if (a) { e.preventDefault(); addVariant(a.dataset.mAddVar, a); }
    });
    cartRoot.addEventListener('change', (e) => {
      const sel = e.target.closest('[data-m-cart-plan]');
      if (sel) change(sel.dataset.mCartPlan, sel.dataset.q, sel.value || null);
      const age = e.target.closest('[data-m-cart-age-input]');
      if (age) {
        $('[data-m-cart-age]', cartRoot).classList.remove('is-missing');
        post('/cart/update.js', { attributes: { 'Mayor de edad': age.checked ? 'Sí' : '' } }).catch(() => {});
      }
    });
    // Antes de pagar: mayoría de edad (si hay alcohol) y datos de factura completos (si la pidió)
    cartRoot.addEventListener('click', (e) => {
      const pay = e.target.closest('[data-m-cart-pay]');
      if (!pay) return;
      const flag = $('[data-m-cart-total]', cartRoot);
      const ageBox = $('[data-m-cart-age]', cartRoot);
      const ageIn = $('[data-m-cart-age-input]', cartRoot);
      if (flag && flag.dataset.alcohol === 'true' && ageIn && !ageIn.checked) {
        e.preventDefault(); ageBox.classList.add('is-missing'); ageBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        toast('Confirma que eres mayor de 18 años para continuar');
        return;
      }
      const invOn = $('[data-m-invoice-toggle]', cartRoot);
      const invStatus = $('[data-m-invoice-status]', cartRoot);
      if (invOn && invOn.checked && invStatus && /^Falta/.test(invStatus.textContent.trim())) {
        e.preventDefault(); invStatus.scrollIntoView({ behavior: 'smooth', block: 'center' });
        toast('Completa tus datos de factura o desmarca "Necesito factura"');
      }
    }, true);

    const recs = async (productId, intent) => {
      const r = await fetch(`/recommendations/products.json?product_id=${productId}&limit=10&intent=${intent}`);
      if (!r.ok) return [];
      return (await r.json()).products || [];
    };
    const lockPay = () => {
      const flag = $('[data-m-cart-total]', cartRoot); const ageIn = $('[data-m-cart-age-input]', cartRoot);
      const locked = !!(flag && flag.dataset.alcohol === 'true' && ageIn && !ageIn.checked);
      $$('[data-m-cart-pay]', cartRoot).forEach((b) => b.classList.toggle('is-locked', locked));
    };
    cartRoot.addEventListener('change', (e) => { if (e.target.closest('[data-m-cart-age-input]')) lockPay(); });
    const initDynamic = async () => {
      lockPay();
      const ship = $('[data-m-cartship]', cartRoot);
      const inCart = new Set((ship?.dataset.inCart || '').split(',').filter(Boolean).map(Number));
      const first = ship?.dataset.first;
      // Sugerencias para llegar a envío gratis: productos que por sí solos cubren lo que falta
      const sugBox = $('[data-m-cartship-sugs]', cartRoot);
      if (sugBox && first) {
        const gap = Number(ship.dataset.gap);
        let list = [...await recs(first, 'related'), ...await recs(first, 'complementary')];
        const seen = new Set();
        list = list.filter((p) => p.available && !inCart.has(p.id) && p.price >= gap && !seen.has(p.id) && seen.add(p.id))
          .sort((a, b) => a.price - b.price).slice(0, 3);
        if (list.length) {
          $('[data-m-cartship-row]', sugBox).innerHTML = list.map((p) => `
            <div class="m-cartsug"><div><a href="${p.url}">${esc(p.title)}</a><strong>${money(p.price)}</strong></div>
            <button type="button" data-m-add-var="${p.variants[0].id}" aria-label="Agregar ${esc(p.title)}">+</button></div>`).join('');
          sugBox.hidden = false;
        }
      }
      // Quienes compran X también se llevan
      const box = $('[data-m-cartrecs]', cartRoot);
      if (box) {
        const pid = new URL(box.dataset.url, location.origin).searchParams.get('product_id');
        let list = await recs(pid, 'complementary');
        if (list.filter((p) => !inCart.has(p.id)).length < 3) list = [...list, ...await recs(pid, 'related')];
        const seen = new Set();
        list = list.filter((p) => p.available && !inCart.has(p.id) && !seen.has(p.id) && seen.add(p.id)).slice(0, 3);
        if (list.length) {
          $('[data-m-cartrecs-items]', box).innerHTML = list.map((p) => `<a class="m-shelf__item" href="${p.url}"><img src="${img(p.featured_image, 300)}" alt="${esc(p.title)}" loading="lazy"></a>`).join('');
          $('[data-m-cartrecs-tags]', box).innerHTML = list.map((p) => `<div class="m-tag m-tag--add"><span class="m-tag__name">${esc(p.title.split(' ').slice(0, 4).join(' '))}</span><span class="m-tag__price">${money0(p.price)}</span><button type="button" class="m-cartrec-add" data-m-add-var="${p.variants[0].id}" aria-label="Agregar ${esc(p.title)}">+</button></div>`).join('');
          box.hidden = false;
        }
      }
    };
    initDynamic();
  }

  /* Búsquedas recientes del cliente: se guardan en este navegador y salen primero en las búsquedas rápidas del inicio */
  const LS_B = 'm_busquedas';
  const leerB = () => { try { return JSON.parse(localStorage.getItem(LS_B) || '[]'); } catch (_) { return []; } };
  document.addEventListener('submit', (e) => {
    const q = e.target.querySelector?.('input[name="q"]')?.value?.trim();
    if (!q || q.length < 2) return;
    try { localStorage.setItem(LS_B, JSON.stringify([q, ...leerB().filter((x) => x.toLowerCase() !== q.toLowerCase())].slice(0, 5))); } catch (_) {}
  }, true);
  $$('[data-m-chips]').forEach((box) => {
    const rec = leerB().slice(0, 3); if (!rec.length) return;
    const ya = new Set($$('.m-chip', box).map((a) => a.textContent.trim().toLowerCase()));
    const esc = (t) => t.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    box.insertAdjacentHTML('afterbegin', rec.filter((q) => !ya.has(q.toLowerCase())).map((q) => `<a class="m-chip m-chip--rec" href="/search?q=${encodeURIComponent(q)}"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg> ${esc(q)}</a>`).join(''));
  });

  /* ¿Una botella o la caja? */
  $$('[data-m-packpick]').forEach(async (box) => {
    const bottles = $('[data-m-pp-bottles]', box);
    // Sin metacampo de packs: los buscamos por título ("Pack de 6 <producto>", "Paquete de 3 …", "Caja de 12 …")
    if (box.dataset.mPpSearch) {
      const base = box.dataset.mPpSearch.trim();
      const norm = (t) => t.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
      try {
        const r = await (await fetch(`/search/suggest.json?q=${encodeURIComponent(base)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide`)).json();
        const found = {};
        for (const p of r.resources?.results?.products || []) {
          const m = norm(p.title).match(/^(?:pack|paquete|caja) de (\d{1,2}) (.*)$/);
          if (m && m[2] === norm(base) && !found[m[1]]) found[m[1]] = { n: +m[1], price: Math.round(parseFloat(p.price) * 100), url: p.url.split('?')[0] };
        }
        const opts = Object.values(found).sort((a, b) => a.n - b.n);
        if (!opts.length) return;
        const wrap = $('.m-packpick__opts', box);
        wrap.insertAdjacentHTML('beforeend', opts.map((o) => `<button type="button" role="radio" class="m-packpick__opt" aria-checked="false" data-n="${o.n}" data-cents="${o.price}" data-price="${money(o.price)}" data-each="${money(Math.round(o.price / o.n))}" data-url="${o.url}">${o.n}</button>`).join(''));
        box.hidden = false;
        const pick = $$('.m-packpick__opt', box).find((x) => x.dataset.n === '6') || $$('.m-packpick__opt', box).pop();
        setTimeout(() => pick?.click(), 0);
      } catch (_) { /* se queda oculto */ }
    }
    const img = bottles?.querySelector('span')?.outerHTML || '';
    const pinta = (n) => {
      if (!bottles) return;
      // Máximo 6 por estante y 2 estantes; si son más de 6 se reparten parejo (8 = 4 + 4, 12 = 6 + 6).
      const filas = n <= 6 ? [n] : [Math.ceil(n / 2), Math.floor(n / 2)];
      const k = Math.max(...filas);
      // Una botella llena el estante; entre más botellas, más chicas, siempre dentro de su lugar.
      const h = filas.length > 1 ? 11 : ({ 1: 24, 2: 22, 3: 19, 4: 16, 5: 14, 6: 13 })[k] || 13;
      bottles.style.setProperty('--k', k); bottles.style.setProperty('--h', `${h}rem`);
      bottles.innerHTML = filas.map((c) => `<div class="m-pp-row" style="--c:${c}">${img.repeat(c)}</div><div class="m-shelf__board"></div>`).join('');
    };
    const elegir = (b) => {
      $$('.m-packpick__opt', box).forEach((x) => { x.classList.toggle('is-active', x === b); x.setAttribute('aria-checked', x === b); });
      const n = Number(b.dataset.n);
      $('[data-m-pp-price]', box).textContent = b.dataset.price;
      $('[data-m-pp-each]', box).textContent = n > 1 ? `${n} botellas · ${b.dataset.each} cada una` : '1 botella';
      $('[data-m-pp-link]', box).href = b.dataset.url;
      const uno = $$('.m-packpick__opt', box).find((x) => x.dataset.n === '1');
      const save = $('[data-m-pp-save]', box);
      if (save && uno && n > 1) {
        const ahorro = Number(uno.dataset.cents) * n - Number(b.dataset.cents);
        const pct = Math.round(ahorro / (Number(uno.dataset.cents) * n) * 100);
        save.hidden = !(ahorro > 0); if (ahorro > 0) save.textContent = `Ahorras ${money(ahorro)}${pct >= 1 ? ` (${pct}%)` : ''} contra comprarlas sueltas`;
      } else if (save) save.hidden = true;
      pinta(n);
    };
    box.addEventListener('click', (e) => { const b = e.target.closest('.m-packpick__opt'); if (b) elegir(b); });
    const ini = $('.m-packpick__opt.is-active', box); if (ini) elegir(ini);
  });

  /* Búsqueda predictiva (BuscarP2): sugerencias, categorías y productos mientras escribes */
  $$('input[type="search"][name="q"]').forEach((input) => {
    const form = input.closest('form'); if (!form) return;
    form.classList.add('m-predict-host');
    const panel = document.createElement('div');
    panel.className = 'm-predict'; panel.hidden = true; panel.setAttribute('role', 'listbox');
    form.appendChild(panel);
    let t; let last = '';
    const close = () => { panel.hidden = true; };
    const run = async () => {
      const q = input.value.trim();
      if (q.length < 2) { close(); return; }
      if (q === last && !panel.hidden) return; last = q;
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=query,product,collection&resources[limit]=5&resources[limit_scope]=each&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor`;
        const r = (await (await fetch(url)).json()).resources?.results || {};
        if (input.value.trim() !== q) return;
        const qs = r.queries || []; const ps = r.products || []; const cs = r.collections || [];
        if (!qs.length && !ps.length && !cs.length) { panel.innerHTML = `<p class="m-predict__none">Sin coincidencias para "${escH(q)}"</p>`; panel.hidden = false; return; }
        panel.innerHTML = `
          <div class="m-predict__col">
            ${qs.length ? `<span class="m-predict__h">Sugerencias</span>${qs.map((x) => `<a class="m-predict__q" href="${x.url}">${escH(x.text)}</a>`).join('')}` : ''}
            ${cs.length ? `<span class="m-predict__h">En categorías</span>${cs.map((x) => `<a class="m-predict__c" href="${x.url}">${escH(x.title)}</a>`).join('')}` : ''}
          </div>
          <div class="m-predict__col m-predict__col--p">
            ${ps.length ? `<span class="m-predict__h">Productos</span>${ps.map((p) => `<a class="m-predict__p" href="${p.url}"><span class="m-predict__img">${p.image ? `<img src="${p.image}${p.image.includes('?') ? '&' : '?'}width=120" alt="" loading="lazy">` : ''}</span><span class="m-predict__name">${escH(p.title)}</span><strong>${money(Math.round(parseFloat(p.price) * 100))}</strong></a>`).join('')}
            <a class="m-predict__all" href="/search?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last">Ver todos los resultados de "${escH(q)}"</a>` : ''}
          </div>`;
        panel.hidden = false;
      } catch (_) { close(); }
    };
    input.setAttribute('autocomplete', 'off');
    input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(run, 180); });
    input.addEventListener('focus', () => { if (input.value.trim().length >= 2) run(); });
    input.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); input.blur(); } });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
  });

  /* Segunda oportunidad: filtros por detalle y departamento (en la página, sin recargar) */
  const segF = $('[data-m-seg-filters]');
  if (segF) {
    const sel = { detalle: '', dep: '' };
    segF.addEventListener('click', (e) => {
      const b = e.target.closest('[data-m-seg-f]'); if (!b) return;
      const k = b.dataset.mSegF; sel[k] = b.dataset.v;
      $$(`[data-m-seg-f="${k}"]`, segF).forEach((x) => x.classList.toggle('is-active', x === b));
      let n = 0;
      $$('.m-segc').forEach((c) => {
        const ok = (!sel.detalle || (c.dataset.detalle || '').split('|').includes(sel.detalle)) && (!sel.dep || c.dataset.dep === sel.dep);
        c.hidden = !ok; if (ok) n += Number(c.dataset.piezas) || 1; // tarjetas agrupadas cuentan sus piezas
      });
      const cnt = $('[data-m-seg-count]'); if (cnt) cnt.textContent = n;
    });
  }

  /* Premium: botella destacada con flechas y filtro de precio */
  const prem = $('[data-m-prem]');
  if (prem) {
    const slides = $$('[data-m-prem-slide]', prem); let i = 0;
    const show = (k) => { i = (k + slides.length) % slides.length; slides.forEach((s, j) => { s.hidden = j !== i; s.classList.toggle('is-active', j === i); }); };
    prem.addEventListener('click', (e) => {
      if (e.target.closest('[data-m-prem-prev]')) show(i - 1);
      if (e.target.closest('[data-m-prem-next]')) show(i + 1);
    });
  }
  /* Premium: filtros por tipo y precio, y orden (todo en la página: la colección cabe completa) */
  const premBox = $('[data-m-prem-filters]');
  if (premBox) {
    const grid = $('.m-prem__grid');
    const st = { sub: '', dep: '', min: 0, max: Infinity, orden: '' };
    const aplicar = () => {
      const items = $$('.m-premc', grid);
      let n = 0;
      items.forEach((c) => {
        const p = Number(c.dataset.price);
        const ok = (!st.sub || c.dataset.sub === st.sub) && (!st.dep || c.dataset.dep === st.dep) && p >= st.min && p <= st.max;
        c.hidden = !ok; if (ok) n++;
      });
      const orden = items.slice().sort((a, b) => {
        if (st.orden === 'asc') return a.dataset.price - b.dataset.price;
        if (st.orden === 'desc') return b.dataset.price - a.dataset.price;
        if (st.orden === 'az') return a.dataset.name.localeCompare(b.dataset.name, 'es');
        return a.dataset.i - b.dataset.i;
      });
      orden.forEach((c) => grid.appendChild(c));
      const cnt = $('[data-m-prem-count]'); if (cnt) cnt.textContent = n === 1 ? '1 producto' : n + ' productos';
    };
    premBox.addEventListener('click', (e) => {
      const b = e.target.closest('.m-chip'); if (!b) return;
      const grupo = b.parentElement;
      $$('.m-chip', grupo).forEach((x) => x.classList.toggle('is-active', x === b));
      if ('sub' in b.dataset) st.sub = b.dataset.sub;
      else if ('dep' in b.dataset) st.dep = b.dataset.dep;
      else { st.min = Number(b.dataset.min || 0); st.max = b.dataset.max ? Number(b.dataset.max) : Infinity; }
      aplicar();
    });
    // ?dep=Vinos y licores (liga desde el home) prende ese filtro al entrar.
    const depUrl = new URLSearchParams(location.search).get('dep');
    if (depUrl) { const ch = $$('[data-sub]', premBox).find((x) => x.dataset.sub.toLowerCase() === depUrl.toLowerCase()); if (ch) ch.click(); }
    // Categorías curadas: "Ver más" deja la colección completa solo con esa categoría y baja a ella.
    const verTipo = (tp, bajar) => {
      const ch = $$('[data-sub]', premBox).find((x) => x.dataset.sub === tp); if (!ch) return;
      const todo = $('[data-dep=""]', premBox); if (todo && st.dep) todo.click();
      ch.click();
      if (bajar) $('#coleccion')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      try { const u = new URL(location.href); u.searchParams.set('tipo', tp); history.replaceState(null, '', u); } catch {}
    };
    $$('[data-m-prem-ver]').forEach((b) => b.addEventListener('click', () => verTipo(b.dataset.mPremVer, true)));
    $$('[data-m-prem-verdep]').forEach((b) => b.addEventListener('click', () => {
      const todo = $('[data-sub=""]', premBox); if (todo && st.sub) todo.click();
      $$('[data-dep]', premBox).find((x) => x.dataset.dep === b.dataset.mPremVerdep)?.click();
      $('#coleccion')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));
    const tipoUrl = new URLSearchParams(location.search).get('tipo');
    if (tipoUrl) setTimeout(() => verTipo(tipoUrl, true), 50);
    // Mosaico "Explora por tipo": filtra la colección y baja a ella
    $$('[data-m-prem-tipo]').forEach((t) => t.addEventListener('click', () => {
      const ch = $$('[data-sub]', premBox).find((x) => x.dataset.sub === t.dataset.mPremTipo); if (ch) ch.click();
      $$('[data-m-prem-tipo]').forEach((x) => x.classList.toggle('is-active', x === t));
      $('.m-prem__col')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));
    const sel = $('[data-m-prem-sort]', premBox);
    if (sel) sel.addEventListener('change', () => { st.orden = sel.value; aplicar(); });
  }

  /* Promesa de entrega según de dónde sale el producto (data-origen):
     bodega    = hay existencia en Pulpo: sale el mismo día hábil si se pide antes del corte.
     crossdock = Vinos y licores sin existencia: compras a proveedor a las 7:00 y 16:30 (lun–vie) y 7:00 (sáb).
                 La de 7:00 llega ~13:00 y sale ese día; la de 16:30 llega al día siguiente 8–9 y sale ese día;
                 la del sábado llega el lunes.
     drop      = el seller manda directo: sale el mismo día hábil si se pide antes de las 12:00.
     Luego se suman días de paquetería (estimado) + un día de colchón. Todo en días hábiles y sin festivos. */
  const ent = $('[data-m-entrega]');
  if (ent) {
    let env = {}; try { env = JSON.parse(ent.dataset.env || '{}') || {}; } catch (_) {}
    const origen = ent.dataset.origen || 'crossdock';
    const habiles = env.dias_habiles || [1, 2, 3, 4, 5];
    const festivos = new Set(env.festivos || []);
    const tr = env.transito || { min: 1, max: 2 };
    const margen = env.margen_dias ?? 0;
    const cfg = Object.assign({ bodega: { corte: 12 }, drop: { corte: 12 }, crossdock: { cortes: [7, 16.5], sabado: 7 } }, env.origenes || {});
    const p = Object.fromEntries(new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Mexico_City', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date()).map((x) => [x.type, x.value]));
    const hoy = new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
    const hora = (+p.hour % 24) + (+p.minute) / 60;
    const iso = (d) => d.toISOString().slice(0, 10);
    const esHabil = (d) => habiles.includes(d.getUTCDay()) && !festivos.has(iso(d));
    const sig = (d) => { const x = new Date(d); x.setUTCDate(x.getUTCDate() + 1); return x; };
    const sumarHabiles = (d, n) => { let x = new Date(d), k = 0; while (k < n) { x = sig(x); if (esHabil(x)) k++; } return x; };
    const proxHabil = (d) => { let x = new Date(d); while (!esHabil(x)) x = sig(x); return x; };
    // Siguiente corte (fecha + hora) y el día que sale si se pide antes de ese corte.
    const cortesDe = (d) => {
      const out = [];
      if (origen === 'crossdock') {
        const [c1, c2] = cfg.crossdock.cortes;
        if (esHabil(d)) { out.push({ h: c1, sale: d }); out.push({ h: c2, sale: sumarHabiles(d, 1) }); }
        else if (d.getUTCDay() === 6 && !festivos.has(iso(d)) && cfg.crossdock.sabado != null) out.push({ h: cfg.crossdock.sabado, sale: sumarHabiles(d, 1) });
      } else if (esHabil(d)) out.push({ h: (cfg[origen] || cfg.drop).corte, sale: d });
      return out;
    };
    let corte = null, dia = new Date(hoy);
    for (let i = 0; i < 10 && !corte; i++, dia = sig(dia)) {
      const c = cortesDe(dia).find((x) => i > 0 || x.h > hora);
      if (c) corte = { ...c, dia: new Date(dia) };
    }
    const salida = proxHabil(corte ? corte.sale : sumarHabiles(hoy, 1));
    const d1 = sumarHabiles(salida, tr.min), d2 = sumarHabiles(salida, tr.max + margen);
    const f = (d, mes) => new Intl.DateTimeFormat('es-MX', { timeZone: 'UTC', weekday: 'short', day: 'numeric', ...(mes ? { month: 'short' } : {}) }).format(d).replace('.', '');
    $('[data-m-entrega-llega]', ent).textContent = iso(d1) === iso(d2) ? `Te llega el ${f(d1, true)}` : `Te llega entre el ${f(d1, d1.getUTCMonth() !== d2.getUTCMonth())} y el ${f(d2, true)}`;
    const sale = $('[data-m-entrega-sale]', ent);
    const nombreDia = (d) => (iso(d) === iso(hoy) ? 'hoy' : iso(d) === iso(sig(hoy)) ? 'mañana' : `el ${new Intl.DateTimeFormat('es-MX', { timeZone: 'UTC', weekday: 'long' }).format(d)}`);
    const horaTxt = (h) => { const hh = Math.floor(h), mm = Math.round((h - hh) * 60); const ap = hh < 12 ? 'am' : 'pm'; return `${((hh + 11) % 12) + 1}${mm ? ':' + String(mm).padStart(2, '0') : ''} ${ap}`; };
    if (corte && iso(corte.dia) === iso(hoy)) {
      const min = Math.max(1, Math.round((corte.h - hora) * 60));
      const h = Math.floor(min / 60), m = min % 60;
      const t = h === 1 && !m ? 'la próxima hora' : h ? `las próximas ${h} h${m ? ' ' + m + ' min' : ''}` : `los próximos ${m} min`;
      sale.textContent = `Pidiendo en ${t}.`;
    } else if (corte) {
      const nd = nombreDia(corte.dia);
      sale.textContent = `Pidiendo antes de las ${horaTxt(corte.h)} ${nd === 'mañana' ? 'de mañana' : nd === 'hoy' ? 'de hoy' : nd.replace(/^el /, 'del ')}.`;
    } else sale.textContent = '';
    ent.hidden = false;
  }

  /* Empresas: qué falta antes de enviar */
  const empForm = $('[data-m-emp-form]');
  if (empForm) {
    const out = $('[data-m-emp-missing]', empForm);
    const RFC = /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/;
    const check = () => {
      const f = (n) => (empForm.querySelector(`[name="${n}"]`)?.value || '').trim();
      const miss = [];
      if (!f('contact[Razón social]')) miss.push('nombre del negocio');
      { const rfcMal = window.mutioRfc(f('contact[RFC]')); if (rfcMal) miss.push(rfcMal); }
      if (!/^\d{5}$/.test(f('contact[CP de entrega]'))) miss.push('código postal');
      if (!f('contact[name]')) miss.push('contacto');
      if (!/\S+@\S+\.\S+/.test(f('contact[email]'))) miss.push('correo');
      if (out) out.textContent = miss.length ? 'Falta: ' + miss.join(', ') : 'Todo listo';
      return miss.length === 0;
    };
    empForm.addEventListener('input', check);
    empForm.addEventListener('submit', (e) => { if (!check()) { e.preventDefault(); e.stopImmediatePropagation(); out?.scrollIntoView({ behavior: 'smooth', block: 'center' }); } });
    check();
  }

  /* Arma tu caja (caja mixta) */
  const caja = $('[data-m-caja]');
  if (caja) {
    let size = 6; const qty = new Map();
    const pct = Number(caja.dataset.pct || 0);
    const cards = $$('.m-cajac', caja);
    const total = () => [...qty.values()].reduce((a, b) => a + b, 0);
    const paint = () => {
      const n = total();
      cards.forEach((c) => { const q = qty.get(c.dataset.id) || 0; $('[data-m-caja-n]', c).textContent = q; c.classList.toggle('is-in', q > 0); $('[data-m-caja-q="1"]', c).disabled = n >= size; });
      $('[data-m-caja-size-label]').textContent = size;
      $('[data-m-caja-prog]').innerHTML = Array.from({ length: size }, (_, i) => `<i class="${i < n ? 'is-on' : ''}"></i>`).join('');
      const falt = size - n;
      $('[data-m-caja-status]').textContent = n === 0 ? 'Elige tus botellas' : falt > 0 ? `Llevas ${n} de ${size}. Faltan ${falt}${pct || Number(caja.dataset.monto6 || 0) ? ' para el precio por caja' : ''}.` : '¡Tu caja está completa!';
      const lines = []; let sub = 0;
      cards.forEach((c) => { const q = qty.get(c.dataset.id) || 0; if (q) { const p = Number(c.dataset.price) * q; sub += p; lines.push(`<li><span>${q} × ${escH(c.dataset.title)}</span><strong>${money(p)}</strong></li>`); } });
      $('[data-m-caja-lines]').innerHTML = lines.join('');
      $('[data-m-caja-sub]').textContent = money(sub);
      const monto = size >= 12 ? Number(caja.dataset.monto12 || 0) : Number(caja.dataset.monto6 || 0);
      const disc = falt === 0 ? (pct ? Math.round(sub * pct / 100) : Math.round(monto * 100 * size)) : 0;
      const dEl = $('[data-m-caja-disc]'); if (dEl) dEl.textContent = disc ? '−' + money(disc) : 'al completarla';
      const tot = sub - disc;
      $('[data-m-caja-total]').textContent = money(tot);
      const free = Number(caja.dataset.free), mid = Number(caja.dataset.mid), cost = Number(caja.dataset.midCost);
      $('[data-m-caja-ship]').textContent = !n ? '' : tot >= free ? 'Envío gratis' : caja.dataset.desde ? `Envío desde ${money0(+caja.dataset.desde)} según peso` : tot >= mid ? `Envío de ${money0(cost)}` : 'El envío se calcula al pagar';
      const btn = $('[data-m-caja-add]'); btn.disabled = falt > 0; btn.textContent = falt > 0 ? `Faltan ${falt} ${falt === 1 ? 'botella' : 'botellas'}` : `Agregar caja · ${money(tot)}`;
      // Caja ilustrada: botellas elegidas arriba, huecos numerados abajo
      const picked = []; cards.forEach((c) => { for (let i = 0; i < (qty.get(c.dataset.id) || 0); i++) picked.push(c.dataset.img); });
      $('[data-m-caja-slots]').innerHTML = Array.from({ length: size }, (_, i) => picked[i] ? `<span class="is-on"><img src="${picked[i]}" alt=""></span>` : `<span><b>${i + 1}</b></span>`).join('');
      $('[data-m-caja-box]').dataset.size = size;
    };
    caja.addEventListener('click', (e) => {
      const b = e.target.closest('[data-m-caja-q]'); if (!b) return;
      const id = b.closest('.m-cajac').dataset.id; const d = Number(b.dataset.mCajaQ);
      if (d > 0 && total() >= size) return;
      qty.set(id, Math.max(0, (qty.get(id) || 0) + d)); paint();
    });
    $$('[data-m-caja-size]').forEach((b) => b.addEventListener('click', () => {
      size = Number(b.dataset.mCajaSize);
      $$('[data-m-caja-size]').forEach((x) => { x.classList.toggle('is-active', x === b); x.setAttribute('aria-checked', x === b); });
      while (total() > size) { const last = [...qty.keys()].reverse().find((k) => qty.get(k) > 0); qty.set(last, qty.get(last) - 1); }
      paint();
    }));
    caja.addEventListener('click', (e) => {
      const f = e.target.closest('[data-m-caja-f]'); if (!f) return;
      $$('[data-m-caja-f]', caja).forEach((x) => x.classList.toggle('is-active', x === f));
      cards.forEach((c) => { c.hidden = !!f.dataset.mCajaF && c.dataset.sub !== f.dataset.mCajaF; });
    });
    $('[data-m-caja-add]').addEventListener('click', async (e) => {
      const btn = e.currentTarget; btn.disabled = true;
      const id = 'C' + Date.now().toString(36).toUpperCase();
      const items = [...qty.entries()].filter(([, q]) => q > 0).map(([vid, q]) => ({ id: Number(vid), quantity: q, properties: { '_Caja mixta': id } }));
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!r.ok) throw new Error((await r.json()).description || 'No se pudo agregar');
        location.href = '/cart';
      } catch (err) { btn.disabled = false; const t = $('[data-m-toast]'); if (t) { t.textContent = err.message; t.hidden = false; } }
    });
    paint();
  }

  /* Zoom de fotos en la ficha: toca la foto para verla en grande; en compu, clic para acercar y mueve el mouse.
     Con varias fotos, flechas (o deslizar, o ← →) para pasar a la siguiente sin cerrar (Mau, 23 oct 2026). */
  const pdpPhoto = $('.m-pdp__photo');
  if (pdpPhoto) {
    const big = (src) => src.replace(/([?&])width=\d+/, '$1width=2000');
    const scope = pdpPhoto.closest('.m-pdp, .m-pdps, main') || document;
    const thumbs = () => $$('[data-m-thumb]', scope);
    const box = document.createElement('div');
    box.className = 'm-zoom'; box.hidden = true; box.setAttribute('role', 'dialog'); box.setAttribute('aria-label', 'Foto en grande');
    box.innerHTML = '<button type="button" class="m-zoom__close" aria-label="Cerrar">×</button>' +
      '<button type="button" class="m-zoom__nav m-zoom__nav--prev" aria-label="Foto anterior">‹</button>' +
      '<div class="m-zoom__stage"><img alt=""></div>' +
      '<button type="button" class="m-zoom__nav m-zoom__nav--next" aria-label="Foto siguiente">›</button>' +
      '<div class="m-zoom__count" aria-live="polite"></div>';
    document.body.appendChild(box);
    const img = $('img', box);
    const prev = $('.m-zoom__nav--prev', box), next = $('.m-zoom__nav--next', box), count = $('.m-zoom__count', box);
    let idx = 0;
    const show = (i) => {
      const t = thumbs();
      if (!t.length) { const cur = $('img', pdpPhoto); if (cur) { img.src = big(cur.currentSrc || cur.src); img.alt = cur.alt || ''; } prev.hidden = next.hidden = true; count.textContent = ''; return; }
      idx = (i + t.length) % t.length;
      img.classList.remove('is-in');
      img.src = big(t[idx].dataset.mThumb); img.alt = t[idx].getAttribute('aria-label') || '';
      prev.hidden = next.hidden = t.length < 2; count.textContent = t.length > 1 ? `${idx + 1} / ${t.length}` : '';
      t[idx].click(); // la foto principal de la ficha también se mueve
    };
    const close = () => { box.hidden = true; img.classList.remove('is-in'); document.documentElement.style.overflow = ''; };
    pdpPhoto.style.cursor = 'zoom-in';
    pdpPhoto.addEventListener('click', () => {
      const t = thumbs(); const a = t.findIndex((x) => x.classList.contains('is-active'));
      show(a >= 0 ? a : 0);
      box.hidden = false; document.documentElement.style.overflow = 'hidden';
    });
    prev.addEventListener('click', (e) => { e.stopPropagation(); show(idx - 1); });
    next.addEventListener('click', (e) => { e.stopPropagation(); show(idx + 1); });
    $('.m-zoom__close', box).addEventListener('click', close);
    box.addEventListener('click', (e) => { if (e.target === box || e.target.classList.contains('m-zoom__stage')) close(); });
    document.addEventListener('keydown', (e) => {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });
    // Deslizar en celular (solo si no está acercada con los dedos).
    let x0 = null;
    box.addEventListener('touchstart', (e) => { x0 = e.touches.length === 1 && (!window.visualViewport || window.visualViewport.scale <= 1.01) ? e.touches[0].clientX : null; }, { passive: true });
    box.addEventListener('touchend', (e) => {
      if (x0 == null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1));
    });
    if (matchMedia('(hover: hover)').matches) {
      img.addEventListener('click', (e) => { e.stopPropagation(); img.classList.toggle('is-in'); });
      img.addEventListener('mousemove', (e) => {
        if (!img.classList.contains('is-in')) return;
        const r = img.getBoundingClientRect();
        img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
      });
    }
  }
  /* ===== Mis pedidos y facturación ===== */
  const fact = $('[data-m-fact]');
  if (fact) {
    const proxy = fact.dataset.proxy;
    const email = fact.dataset.email;
    let data = {};
    try { data = JSON.parse($('[data-m-fact-data]').textContent); } catch (e) {}
    let perfiles = Array.isArray(data.perfiles) ? data.perfiles : [];
    const REG = Object.fromEntries((data.regimenes || []).map((r) => r.split('|')));
    const USO = Object.fromEntries((data.usos || []).map((r) => r.split('|')));
    const toastEl = $('[data-m-fact-toast]');
    const toast = (msg, err) => { toastEl.textContent = msg; toastEl.classList.toggle('is-error', !!err); toastEl.hidden = false; toastEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); };
    const api = async (path, opts = {}) => {
      const r = await fetch(proxy + path, { credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, ...opts });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.error || 'No pudimos completar la solicitud. Intenta de nuevo en un momento.');
      return j;
    };
    // Pestañas internas
    const showTab = (id) => {
      $$('[data-m-fact-panel]', fact).forEach((p) => { p.hidden = p.dataset.mFactPanel !== id; });
      $$('.m-acct__tab[data-m-fact-tab]', fact).forEach((t) => { const on = t.dataset.mFactTab === id; t.classList.toggle('is-active', on); if (on) t.setAttribute('aria-current', 'page'); else t.removeAttribute('aria-current'); });
      toastEl.hidden = true;
    };
    $$('[data-m-fact-tab]', fact).forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); showTab(a.dataset.mFactTab); history.replaceState(null, '', '#' + a.dataset.mFactTab); }));
    if (location.hash === '#rfc') showTab('rfc');

    // Estado de cada pedido
    const pintar = (ord, f) => {
      const box = $('[data-m-ord-inv]', ord); const ask = $('[data-m-ord-ask]', ord);
      box.classList.remove('is-done', 'is-working', 'is-closed');
      const title = $('[data-m-ord-title]', ord); const note = $('[data-m-ord-note]', ord);
      if (f.estado === 'hecha') {
        box.classList.add('is-done');
        title.textContent = 'Facturada a ' + f.rfc;
        note.textContent = (f.nombre ? f.nombre + ' · ' : '') + 'Se envió a ' + email + '.';
        const files = $('[data-m-ord-files]', ord);
        if (f.pdf || f.xml) { files.hidden = false; $('[data-m-ord-pdf]', ord).href = f.pdf || '#'; $('[data-m-ord-xml]', ord).href = f.xml || '#'; }
        if (ask) ask.hidden = true;
      } else if (f.estado === 'en_proceso' || f.estado === 'revisar') {
        box.classList.add('is-working');
        title.textContent = 'Facturando a ' + (f.rfc || ord.dataset.rfc);
        note.textContent = f.mensaje || ('Llega a ' + email + ' en unas horas.');
        if (ask) ask.hidden = true;
      } else if (f.estado === 'error') {
        title.textContent = 'No se pudo facturar';
        note.textContent = f.mensaje || 'Revisa que los datos coincidan con tu constancia y vuelve a pedirla.';
        if (ask && ord.dataset.estado !== 'cerrado') ask.hidden = false;
      }
      if (ord.dataset.estado === 'cerrado' && f.estado !== 'hecha') box.classList.add('is-closed');
    };
    const ords = $$('[data-m-ord]', fact);
    ords.forEach((o) => { if (o.dataset.estado === 'en_proceso') $('[data-m-ord-inv]', o).classList.add('is-working'); if (o.dataset.estado === 'cerrado') $('[data-m-ord-inv]', o).classList.add('is-closed'); });
    if (ords.length) {
      api('/facturas?pedidos=' + encodeURIComponent(ords.map((o) => o.dataset.mOrd).join(',')))
        .then((j) => ords.forEach((o) => { const f = (j.facturas || {})[o.dataset.mOrd]; if (f) pintar(o, f); }))
        .catch(() => {});
    }

    // Pedir factura
    const elegir = (ord) => {
      const box = $('[data-m-ord-choices]', ord);
      if (!perfiles.length) { box.innerHTML = '<span class="m-ord__hint">Primero guarda un RFC en Datos de facturación.</span>'; return; }
      const def = perfiles.find((p) => p.predeterminado) || perfiles[0];
      box.innerHTML = perfiles.map((p) => `<button type="button" class="m-ord__choice${p.id === def.id ? ' is-active' : ''}" data-id="${escH(p.id)}" aria-pressed="${p.id === def.id}"><strong>${escH(p.alias)} · ${escH(p.rfc)}</strong><small>${escH(p.nombre)}</small></button>`).join('');
      $$('.m-ord__choice', box).forEach((b) => b.addEventListener('click', () => { $$('.m-ord__choice', box).forEach((x) => { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', x === b); }); }));
    };
    ords.forEach((ord) => {
      const ask = $('[data-m-ord-ask]', ord); const form = $('[data-m-ord-form]', ord);
      ask?.addEventListener('click', () => { elegir(ord); form.hidden = false; ask.hidden = true; });
      $$('[data-m-ord-forma]', ord).forEach((b) => b.addEventListener('click', () => $$('[data-m-ord-forma]', ord).forEach((x) => x.classList.toggle('is-active', x === b))));
      $('[data-m-ord-confirm]', ord)?.addEventListener('click', async (e) => {
        const id = $('.m-ord__choice.is-active', ord)?.dataset.id; const p = perfiles.find((x) => x.id === id);
        if (!p) { showTab('rfc'); return; }
        const forma = $('[data-m-ord-forma].is-active', ord)?.dataset.mOrdForma || '04';
        e.currentTarget.disabled = true;
        try {
          await api('/facturas', { method: 'POST', body: JSON.stringify({ pedido: ord.dataset.mOrd, rfc: p.rfc, nombre: p.nombre, regimen: p.regimen, cp: p.cp, uso: p.uso, forma }) });
          form.hidden = true;
          pintar(ord, { estado: 'en_proceso', rfc: p.rfc });
          toast('Listo, estamos facturando el pedido #' + ord.dataset.mOrd + ' a ' + p.rfc + '.');
        } catch (err) { toast(err.message, true); e.currentTarget.disabled = false; }
      });
    });

    // RFC guardados
    const lista = $('[data-m-rfcs]', fact);
    const guardar = async (nuevos, msg) => {
      const j = await api('/rfcs', { method: 'POST', body: JSON.stringify({ rfcs: nuevos }) });
      perfiles = Array.isArray(j.rfcs) ? j.rfcs : nuevos; pintarRfcs(); if (msg) toast(msg);
    };
    const pintarRfcs = () => {
      if (!lista) return;
      lista.innerHTML = perfiles.map((p) => `<div class="m-rfc${p.predeterminado ? ' is-default' : ''}"><div class="m-rfc__head"><strong>${escH(p.alias)}</strong>${p.predeterminado ? '<span class="m-rfc__badge">Predeterminado</span>' : ''}</div><dl><dt>RFC</dt><dd>${escH(p.rfc)}</dd><dt>Nombre</dt><dd>${escH(p.nombre)}</dd><dt>Régimen</dt><dd>${escH(p.regimen)} · ${escH(REG[p.regimen] || '')}</dd><dt>CP fiscal</dt><dd>${escH(p.cp)}</dd><dt>Uso CFDI</dt><dd>${escH(p.uso)} · ${escH(USO[p.uso] || '')}</dd></dl><div class="m-rfc__actions">${p.predeterminado ? '' : `<button type="button" data-def="${escH(p.id)}">Usar como predeterminado</button>`}<button type="button" data-del="${escH(p.id)}">Eliminar</button></div></div>`).join('');
      $$('[data-def]', lista).forEach((b) => b.addEventListener('click', () => guardar(perfiles.map((p) => ({ ...p, predeterminado: p.id === b.dataset.def })), 'RFC predeterminado actualizado.').catch((e) => toast(e.message, true))));
      $$('[data-del]', lista).forEach((b) => b.addEventListener('click', () => { const p = perfiles.find((x) => x.id === b.dataset.del); guardar(perfiles.filter((x) => x.id !== b.dataset.del), (p?.alias || 'RFC') + ' eliminado.').catch((e) => toast(e.message, true)); }));
    };
    pintarRfcs();
    const rf = $('[data-m-rfc-form]', fact);
    if (rf) {
      let reg = null; let uso = 'G03';
      const RFC_RE = /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/;
      const val = () => {
        const f = Object.fromEntries(new FormData(rf)); const r = (f.rfc || '').trim().toUpperCase();
        const moral = r.length === 12;
        const ok = moral ? ['601', '603', '626'] : ['605', '606', '612', '616', '621', '625', '626'];
        $$('[data-reg]', rf).forEach((b) => { b.hidden = r.length >= 12 && !ok.includes(b.dataset.reg); if (b.hidden && reg === b.dataset.reg) { reg = null; b.classList.remove('is-active'); } });
        const falta = [];
        { const rfcMal = window.mutioRfc(r, reg); if (rfcMal) falta.push(rfcMal); }
        if (!(f.nombre || '').trim()) falta.push('nombre o razón social');
        if (!/^\d{5}$/.test((f.cp || '').trim())) falta.push('CP fiscal');
        if (!reg) falta.push('régimen');
        $('[data-m-rfc-status]', rf).textContent = falta.length ? 'Falta: ' + falta.join(', ') : 'Listo para guardar.';
        $('[data-m-rfc-save]', rf).disabled = falta.length > 0;
        return { falta, f, r };
      };
      rf.addEventListener('input', val);
      $$('[data-reg]', rf).forEach((b) => b.addEventListener('click', () => { reg = b.dataset.reg; $$('[data-reg]', rf).forEach((x) => x.classList.toggle('is-active', x === b)); val(); }));
      $$('[data-uso]', rf).forEach((b) => b.addEventListener('click', () => { uso = b.dataset.uso; $$('[data-uso]', rf).forEach((x) => x.classList.toggle('is-active', x === b)); }));
      rf.addEventListener('submit', async (e) => {
        e.preventDefault();
        const { falta, f, r } = val(); if (falta.length) return;
        const nuevo = { id: 'r' + Date.now().toString(36), alias: (f.alias || '').trim() || r, rfc: r, nombre: f.nombre.trim().toUpperCase(), regimen: reg, cp: f.cp.trim(), uso, predeterminado: perfiles.length === 0 };
        $('[data-m-rfc-save]', rf).disabled = true;
        try { await guardar(perfiles.concat(nuevo), nuevo.alias + ' guardado.'); rf.reset(); reg = null; $$('[data-reg]', rf).forEach((x) => x.classList.remove('is-active')); val(); }
        catch (err) { toast(err.message, true); val(); }
      });
      val();
    }
  }
})();

/* Bloques de confianza del inicio: los meses sin intereses siguen lo que da Mercado Pago (window.mMsi). */
(() => {
  const n = typeof window.mMsi === 'number' ? window.mMsi : 3;
  document.querySelectorAll('.m-trust__item').forEach((it) => {
    const s = it.querySelector('strong'); if (!s || !/meses sin intereses/i.test(s.textContent)) return;
    if (n < 2) it.remove(); else s.textContent = `Hasta ${n} meses sin intereses`;
  });
  // Envío: montos de Shopify (window.mEnvio), por si la sección guardada en Shopify trae textos viejos.
  const e = window.mEnvio || {};
  const fm = (x) => '$' + Number(x).toLocaleString('es-MX');
  if (e.gratis) document.querySelectorAll('.m-trust__item').forEach((it) => {
    const s = it.querySelector('strong'); if (!s || !/env[ií]o gratis/i.test(s.textContent)) return;
    s.textContent = `Envío gratis desde ${fm(e.gratis)}`;
    const t = it.querySelector('span'); if (t && e.desde) t.textContent = `Abajo de eso, envío desde ${fm(e.desde)} según el peso.`;
  });
})();


/* Leads (Empresas y Eventos, 19 oct 2026): se mandan a tienda-mutio por el app proxy. Si falla, se usa el formulario de
   contacto de Shopify. Al enviarse dispara el evento "Lead" para Meta y Google (solo si sus etiquetas ya están instaladas). */
(() => {
  // Google Ads (cuenta Mutio 463-280-7407): la etiqueta de la app (GT-NSSMKC7R) no trae esta cuenta, así que la
  // configuramos aquí. gtag en cola: si la etiqueta de Google carga después, procesa estos comandos al llegar.
  const ADS = 'AW-11071619186';
  const LEAD = `${ADS}/SqVFCLC9m6QdEPKArp8p`; // conversión "Cliente potencial" (20 oct 2026)
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') window.gtag = function () { window.dataLayer.push(arguments); };
  try { window.gtag('config', ADS); } catch (e) {}
  window.mutioLead = (tipo) => {
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'generate_lead', lead_type: tipo }); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_category: tipo }); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { lead_type: tipo }); } catch (e) {}
    try { window.gtag('event', 'conversion', { send_to: LEAD, lead_type: tipo }); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('mutio:lead', { detail: { tipo } })); } catch (e) {}
  };
  document.querySelectorAll('[data-m-lead-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      if (e.defaultPrevented) return;
      e.preventDefault();
      const tipo = form.dataset.mLeadForm;
      const btn = form.querySelector('button[type="submit"]');
      const msg = form.querySelector('[data-m-lead-msg], [data-m-emp-missing]');
      const fd = new FormData(form);
      const v = (k) => String(fd.get(`contact[${k}]`) || '').trim();
      const campos = {};
      for (const [k, val] of fd.entries()) {
        const m = /^contact\[(.+)\]$/.exec(k); if (!m) continue;
        const n = m[1]; if (['name', 'email', 'phone', 'Asunto', 'sitio_web'].includes(n) || !String(val).trim()) continue;
        campos[n === 'body' ? 'Comentarios' : n] = String(val).trim();
      }
      if (btn) { btn.disabled = true; btn.dataset.txt = btn.textContent; btn.textContent = 'Enviando…'; }
      try {
        const r = await fetch('/apps/mutio/leads', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ tipo, nombre: v('name'), correo: v('email'), telefono: v('phone'), sitio_web: v('sitio_web'), campos }) });
        const j = await r.json().catch(() => ({}));
        if (r.status === 400 && j.error) { if (msg) msg.textContent = j.error; if (btn) { btn.disabled = false; btn.textContent = btn.dataset.txt; } return; }
        if (!r.ok || !j.ok) throw new Error(j.error || 'error');
        window.mutioLead(tipo);
        form.innerHTML = tipo === 'empresas'
          ? '<div class="m-emp__ok"><strong>¡Recibimos tu solicitud!</strong><span>Te mandamos un correo de confirmación y te escribimos en un día hábil.</span></div>'
          : '<div class="m-emp__ok"><strong>¡Recibimos los datos de tu evento!</strong><span>Te mandamos un correo de confirmación y tu propuesta en un día hábil.</span></div>';
      } catch (err) {
        window.mutioLead(tipo);
        HTMLFormElement.prototype.submit.call(form); // respaldo: formulario de contacto de Shopify
      }
    });
  });
})();
